module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Triangle-37cbf9c9a191d6dffc6305779870813a.svg";